var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import Box from '@mui/material/Box';
import { useNavigate } from 'react-router-dom';
import { useSystemConfigRestore, useUploadSystemConfigRestore } from '@/api/system/config/system-config';
import { ResetButton, FormContainer, FormActions, SubmitButton } from '@/components/layout/forms';
import { BackupUploadField, ConfigRestoreConfirmModal, ConfigRestorePasswordField } from './config-restore-form-controls';
import { transformConfigRestoreForm } from './config-restore-form-transformers';
import { useOpen } from '@/hooks/open';
import { formatConfigRestoreStatusRoute } from '@/constants/routes';
export var defaultValues = {
    file: null,
    password: '',
};
export function ConfigRestoreForm(_a) {
    var _this = this;
    var permissions = _a.permissions;
    var t = useTranslation().t;
    var uploadRestoreRequest = useUploadSystemConfigRestore();
    var systemRestoreRequest = useSystemConfigRestore();
    var navigate = useNavigate();
    var methods = useForm({ mode: 'onTouched', defaultValues: defaultValues });
    var _b = __read(useState(undefined), 2), backupDetails = _b[0], setBackupDetails = _b[1];
    var _c = useOpen(), open = _c.open, handleConfirmRestoreClose = _c.handleClose, handleConfirmRestoreOpen = _c.handleOpen;
    var handleSuccessfulUpload = useCallback(function (configBackupDetails) {
        setBackupDetails(configBackupDetails);
        handleConfirmRestoreOpen();
    }, [handleConfirmRestoreOpen]);
    var handleUploadSubmit = useCallback(function (formData) { return __awaiter(_this, void 0, void 0, function () {
        var transformedData, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    transformedData = transformConfigRestoreForm(formData);
                    if (!transformedData) return [3 /*break*/, 2];
                    return [4 /*yield*/, uploadRestoreRequest(transformedData)];
                case 1:
                    response = _a.sent();
                    if (response) {
                        methods.reset(defaultValues);
                        handleSuccessfulUpload(response);
                    }
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); }, [uploadRestoreRequest, handleSuccessfulUpload, methods]);
    var handleRestoreSubmit = useCallback(function (configDetails) { return __awaiter(_this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, systemRestoreRequest({ id: configDetails.system_upload_restore.id })
                    // Catch undefined response
                ];
                case 1:
                    response = _a.sent();
                    // Catch undefined response
                    if (!response)
                        return [2 /*return*/];
                    handleConfirmRestoreClose();
                    navigate(formatConfigRestoreStatusRoute(configDetails.system_upload_restore.id), {
                        replace: true,
                        state: { configRestoreResponseStatus: response.system_config_restore.status },
                    });
                    return [2 /*return*/];
            }
        });
    }); }, [handleConfirmRestoreClose, navigate, systemRestoreRequest]);
    return (_jsxs(_Fragment, { children: [backupDetails && (_jsx(ConfigRestoreConfirmModal, { open: open, backupDetails: backupDetails, onClose: handleConfirmRestoreClose, onSubmit: handleRestoreSubmit })), _jsxs(FormContainer, __assign({ mode: "create", permissions: permissions, methods: methods, onSubmit: handleUploadSubmit }, { children: [_jsx(BackupUploadField, {}), _jsx(Box, __assign({ marginTop: 2 }, { children: _jsx(ConfigRestorePasswordField, {}) })), _jsxs(FormActions, { children: [_jsx(ResetButton, {}), _jsx(SubmitButton, { children: t('pages.backup_restore_reset.tabs.config_restore.form.restore_button') })] })] }))] }));
}
